import { TemplateRef, Type } from '@angular/core';
import { FormControl, ValidatorFn } from '@angular/forms';

import { NgClass } from '../../interfaces/helper-types';
import { ButtonType } from '../buttons/button-main';

export enum ModalInputTypeEnum {
    Checkbox = 'checkbox',
    Number = 'number',
    Radio = 'radio',
    Select = 'select',
    Text = 'text',
    Textarea = 'textarea',
    Date = 'date',
}

export interface ModalInput {
    type: ModalInputTypeEnum;
    formControl: FormControl;
    id?: number;
    name?: string;
    placeholder?: string;
    errors?: { [key: string]: string };
    label?: string;
    disabled?: boolean;
    hidden?: boolean;
    min?: string | number | Date;
    max?: string | number | Date;
    options?: { value: string; translation: string }[];
    class?: NgClass;
    callbackOnChange?(event: any): void;
    autofocus?: boolean;
    rows?: number;
}

export interface ModalInterface {
    title?: string;
    titleParams?: Params;
    contentParagraphClass?: NgClass;
    buttons?: ButtonInterface[];
    denyClose?: boolean;
    size?: string;
    onClose?: () => void;
    contentItems?: ModalContentItem[];
    headerImage?: string;
}

interface Params {
    [key: string]: number | string;
}

export interface ButtonInterface {
    label: string;
    type?: ButtonType | keyof typeof ButtonType;
    destructive?: boolean;
    disabled?: boolean;
    relatedInput?: ModalInput;
    relatedInputs?: ModalInput[];
    customValidator?: ValidatorFn;
    saving?: boolean;
    callback?(...rest): any;
}

export type ModalContentItem = {
    contentString?: string;
    contentTranslationKey?: string;
    contentHTML?: string;
    contentParams?: Params;
    contentParagraphClass?: NgClass;
    contentTemplateRef?: TemplateRef<any>;
    contentComponent?: Type<any>;
    componentInputs?: Record<string, unknown>;
} & {
    ngClass?: NgClass;
} & Partial<ModalInput>;
